// src/components/Footer.js
import React from 'react';
import './Footer.css'; // We'll define styles here

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-logo">
        <h1 className="kh-animation">KHAutomations</h1>
      </div>
      <div className="footer-links">
       
        <div className="column">
          <h3>Our Services</h3>
          <p>CCTV Installation</p>
          <p>Bio Metric Installation</p>
          <p>Terrace Decoration</p>
          <p>Home Automation</p>
        </div>
        {/* <div className="column">
          <h3>About Us</h3>
          <p>FAQ</p>
        </div> */}
         <div className="column">
          <h3>Address</h3>
          <p>   Tavarekere Main Rd
                <br />
                1st Stage, BTM Layout, Bengaluru
                <br />
                Opposite to Mythree Mart Super Market
                <br />
                Karnataka, India 560029 </p>
          
        </div>
        
        <div className="column">
          <h3>Connect with Us</h3>
          <p>(+91)-6302536200</p>
          <p>(+91)-6361620953</p>
        </div>
      </div>

      <div className="footer-bottom">
  <p>COPYRIGHT 2024 © KH-Automations. ALL RIGHTS RESERVED.</p>
  <p>
    
    <a
      className="textcodeserver"
      href="https://www.codeserver.in"
      target="_blank"
      rel="noopener noreferrer"
    >
      Made with ❤ by{' '} Codeserver Technology
    </a>
  </p>
</div>



    </footer>
  );
};

export default Footer;
